import React, { useEffect, useState } from 'react';
import { axiosInstance } from '../App';

/**
 * PartnerDropdown - reusable <select> that loads active partners from /api/partners.
 *
 * Props:
 *   value           : current partner_id
 *   onChange(id)    : called with partner_id string
 *   required        : if true, shows * indicator
 *   includeHistorical (bool, default false): allow selecting the 'historical' bucket
 *   testId          : data-testid for the <select>
 *   placeholder     : first-option text
 *   label           : optional label rendered above
 *   disabled        : disables select
 */
export const PartnerDropdown = ({
  value,
  onChange,
  required = false,
  includeHistorical = false,
  testId = 'partner-select',
  placeholder = 'Select partner…',
  label,
  disabled = false,
}) => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    axiosInstance.get('/partners').then((r) => {
      const list = Array.isArray(r.data) ? r.data : [];
      setPartners(includeHistorical ? list : list.filter((p) => p.id !== 'historical'));
    }).catch(() => setPartners([]));
  }, [includeHistorical]);

  return (
    <div>
      {label && (
        <label className="block text-xs font-medium text-gray-600 mb-1">
          {label}{required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        data-testid={testId}
        className="form-input w-full text-sm"
      >
        <option value="">{placeholder}</option>
        {partners.map((p) => (
          <option key={p.id} value={p.id}>{p.name || p.username}</option>
        ))}
      </select>
    </div>
  );
};
